export default Object.freeze({
  USER_DETAILS: 'userDetails',
  TEMP_USER_DETAILS: 'tempUserDetails',
  OFFICES: 'offices',

  CLIENTS: 'clients',
  OPERATORS: 'operators',
  OPERATOR_STRIPES: 'operatorStripes',
  TRANSFERS: 'transfers',
  PAYOUTS: 'payouts',
  SCORE: 'scores',
  SCORE_LOGS: 'scoreLogs',

  WORKS: 'works',
  TEMPS: 'temps',

  MATCHINGS: 'matchings',
  MESSAGES: 'messages',
});